import { render, staticRenderFns } from "./new_product.vue?vue&type=template&id=23fa3cf8&scoped=true"
import script from "./new_product.vue?vue&type=script&lang=js"
export * from "./new_product.vue?vue&type=script&lang=js"
import style0 from "./new_product.vue?vue&type=style&index=0&id=23fa3cf8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa3cf8",
  null
  
)

export default component.exports